import { API_FACTORY } from '@connect-x-app/shared-utils';

import HttpClient from '../utils/http/httpClient';

export const getQuickReplies = (): Promise<string[]> =>
  HttpClient.get<{ quickReplies: string[] }>(API_FACTORY.v1('messages/quick-replies')).then(data => data.quickReplies);
